import { BarceloComponent } from "components-utils";

const MenuComponents = {
  stripeMenu: BarceloComponent({
    selector: ".c-stripemenu, .stripemenu",
    path: "barcelo/menu/stripemenu/js/c-stripemenu",
  }),

  vMenu: BarceloComponent({
    selector: ".c-submenu-container, .c-v-menu, .header, .c-header",
    path: "barcelo/menu/v-menu/js/v-menu",
  }),
};

export default MenuComponents;
